/*
En este fichero se importan, se cargan y se configura todos los componentes
genéricos a utilizar dentro de la web de cifra
*/
import Overlay from '../../libs/cifra/overlay';
import * as http from '../../libs/http';

// eslint-disable-next-line import/prefer-default-export
export function registrarComponentes() {
  window.Cifra.Components.Overlay = Overlay;
  window.Cifra.Libs = {
    http,
  };
}
